export default __webpack_public_path__ + "static/media/perdaIcone.8f823fbd.svg";